import { Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { ICON_LIST } from '../utilities/const/iconList';

@Component({
  selector: 'app-icon',
  standalone: true,
  template: `
  @if(isSvgIcon()) {
    <div
      [innerHTML]="iconHtml()"
      [ngClass]="className()"
      [class.rotate-180]="isIconRotate()"
    ></div>
  } @else if(isPathIcon()) {
      <svg xmlns="http://www.w3.org/2000/svg" [attr.fill]="fill()" [attr.stroke]="stroke()" viewBox="0 0 24 24" [class]="setClass()">
        <path stroke-linecap="round" stroke-linejoin="round" [attr.stroke-width]="strokeWidth()" [attr.d]="icon()"></path>
      </svg>
  }`,
  imports: [CommonModule],
  styles: [`
    :host {
      display: inline-flex;
    }
  `]
})
export class Icon {
  iconName = input.required<keyof typeof ICON_LIST>();
  fill = input<string>('none');
  stroke = input<string>('');
  className = input<string>('');
  isIconRotate = input<boolean>(false);
  strokeWidth = input<string>("2");

  icon = computed(() => ICON_LIST[this.iconName()]);
  isSvgIcon = computed(() => ICON_LIST[this.iconName()].startsWith('<svg'));
  isPathIcon = computed(() => !(ICON_LIST[this.iconName()].startsWith('<svg')));

  setClass = computed(() => `shrink-0 w-4 h-4 ${this.className()}`);

  constructor(private sanitizer: DomSanitizer) { }

  iconHtml = computed(() => {
    const icon = this.icon();

    if (this.isSvgIcon())
      return this.sanitizer.bypassSecurityTrustHtml(icon);
    return '';
  });
}
